export const scrollToElement = (id: string, position: ScrollLogicalPosition = 'center') => {
  const elem = document.getElementById(id);

  if (elem) {
    elem.scrollIntoView({ behavior: 'smooth', block: position });
  }
};
